import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    tableContainer: {
      maxHeight: 'none',
    },
    table: {
      minWidth: 750,
    },
    tableMessage: {
      padding: 10,
    },
    header: {
      backgroundColor: '#c0c0c0',
    },
    headerCell: {
      cursor: 'pointer',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
  })
);

export type TableStyles = typeof useStyles;
